
import { Component, Input, Output, Pipe, PipeTransform, EventEmitter, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { DateModel, GQueovalDik, QueovalDateTime } from '../../../models';
import { BooleanBoProperty, BoPropertyType, DateRequiredBoProperty, IBoProperty, MonetaryBoProperty } from '../../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { MoneyPipe } from '../../../pipes';
import { CoreService, HttpService, QueovalDateService } from '../../../services';
import { parseTime } from '../../../utilities';


@Component({
  selector: 'q-bo-property-inline',
  templateUrl: './bo-property-inline.component.html',
  styleUrls: ['./bo-property-inline.component.css']  
})

export class BoPropertyInlineComponent implements AfterContentChecked {
  public uuid: string = Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);

  public displayMode: string = 'ROUNDED_BUTTON';

  public type: BoPropertyType = BoPropertyType.STRING;
  public buttonCustomClass: string = '';
  public overrideBackgroundColor: boolean;
  //#region COMBO
  public TypePopover: any;
  //#endregion

  //#region case DATE
  public datepiquerPopover: any;
  public PropPopover: any;
  //#endregion

  private typed: boolean = false;

  public dtValue: Date | null = null;

  public get DateMinutesList(): Array<string> {
    return (this.property as DateRequiredBoProperty)?.DateMinutesList;
  }

  @Input() property: IBoProperty<any>
  @Input('type') set SetType(value: BoPropertyType) {
    this.type = value;
    this.typed = true;
  }
  @Input('mode') set SetMode(value: string) {
    if (!value) {
      this.displayMode = 'ROUNDED_BUTTON';
      return;
    }
    switch (value.toLocaleUpperCase()) {
      case 'INPUT':
        this.displayMode = 'INPUT'
        break;
      default:
        this.displayMode = 'ROUNDED_BUTTON';
        break;
    }
  }
  @Input('button-custom-class') set SetBgColor(value: string) {
    this.overrideBackgroundColor = [
      'q-main', 'q-dark-main', 'q-light-main',
      'q-secondary', 'q-dark-secondary', 'q-light-secondary',
      'q-black', 'q-light-black',
      'q-grey', 'q-dark-grey', 'q-light-grey',
      'q-warning', 'q-success', 'q-danger', 'q-white', 'q-primary', 'q-dark-primary'
    ].filter(color => value.includes(color)).length > 0;
    this.buttonCustomClass = value;

  }

  @Output() close: EventEmitter<IBoProperty<any>> = new EventEmitter<IBoProperty<any>>(true);

  constructor(
    private http: HttpService,
    public qDateService: QueovalDateService,
    public indParam: CoreService,
    public cd: ChangeDetectorRef,
    private dtService: QueovalDateService
  ) { }

  ngAfterContentChecked() {
    if (!this.typed && this.property.Type)
      this.type = this.property.Type;

    if (this.type == BoPropertyType.DATE && this.displayMode == 'INPUT' && !this.dtService.IsNull((this.property.Value as QueovalDateTime))) {
      this.dtValue = this.dtService.ToDateTime((this.property.Value as QueovalDateTime));
      //si une date valide est renseignée on fait le getDate
        this.getDate(`${this.property.Value.annee}-${this.property.Value.mois}-${this.property.Value.jour}`);
    }
    this.cd.detectChanges();
  }

  public OnSave(): void {
    if (this.property.ColumnName) {
      const model: Array<IBoProperty<any>> = [this.property];
      this.http.postHttp<boolean>(`${this.indParam.AppParams.apiUrl}api/dynamictags/SAVE_PROPERTIES`, model).subscribe();
    }
  }

  public PopoverClosed(): void {
    this.close.emit(this.property);
  }
  //#region COMBO
  public AfficheComboValue(Prop: IBoProperty<any>): string {
    var selectedValue = (Prop.Combo as Array<GQueovalDik<string, any>>).filter((combo: GQueovalDik<string, any>) => combo.Value === Prop.Value)
    if (selectedValue && selectedValue.length > 0 && selectedValue[0] != null) return selectedValue[0].Key;
    Prop.Value = (Prop.Combo as Array<GQueovalDik<string, any>>)[0].Value
    return (Prop.Combo as Array<GQueovalDik<string, any>>)[0].Key;
  }

  public OnChangeComboValue(Prop: IBoProperty<any>, value: any): void {
    Prop.Value = value;
    this.TypePopover.close();
  }
  //#endregion

  //#region DATE
  public datePropChange(Prop: DateRequiredBoProperty, date: DateModel): void {
    let heures: string = Prop.Value != null ? Prop.Value.heures : '00';
    let minutes: string = Prop.Value != null ? Prop.Value.minutes : '00';
    Prop.Value = new QueovalDateTime(date.year.toString(), date.month.toString(), date.day.toString(), heures, minutes);
  }

  /**
 * Affecte la date de l'input au model
 * @param pValue string date retourné par l'input (format yyyy-MM-jj)
 */
  public OnBlur(pValue: string): void {
    //élément de l'input type date dans lequel stoquer la date (sans les heures)
   
    if (pValue !== '') {
      this.getDate(pValue)
    }
    else {
      this.dtValue = null;
      this.property.Value = new QueovalDateTime();
    }   
  }

  /**
 * gère l'affectation de la date à l'init et au blur de l'input
 * @param pStrDate format yyyy-MM-jj
 */
  private getDate(pStrDate: string): void {
    // déclaration de la date du jour
    const dateOfDay: Date = new Date();
    const dayOfDay: number = dateOfDay.getDate();
    const monthOfDay: number = dateOfDay.getMonth() + 1;
    const yearOfDay: number = dateOfDay.getFullYear();

    // renvoie la date du jour si la date récupérée est 0000-00-00
    const lstDate: Array<string> = pStrDate.split('-');
    let year: number = Number(lstDate[0]);
    //si l'année = '0000' => année en cours || si l'année < 100 => 20XX (XX compris entre 01 et 99) || sinon => valeur saisie
    year = lstDate[0] === '0000' ? yearOfDay : year < 100 ? Number(`20${parseTime(year)}`) : Number(lstDate[0]);
    const month: number = lstDate[1] === '00' ? monthOfDay : Number(lstDate[1]);
    const day: number = lstDate[2] === '00' ? dayOfDay : Number(lstDate[2]);
    const hour: number = Number((this.property as DateRequiredBoProperty).Value?.heures) ?? 0;
    const minute: number = Number((this.property as DateRequiredBoProperty).Value?.minutes) ?? 0;

    // les mois sont décalés de 1 à cause du rang du premier argument d'une liste qui est 0
    this.dtValue = new Date(year, month - 1, day, hour, minute, 0, 0);
    // affection de la date au datepicker
    (this.property as DateRequiredBoProperty).Value = this.qDateService.FromDateTime(this.dtValue);
  }

  public OnPropHourChange(Prop: IBoProperty<QueovalDateTime>, hour: string, isInput: boolean): void {
    if (Prop.Value != null) {
      Prop.Value.heures = hour;
      Prop.Value = new QueovalDateTime(Prop.Value.annee, Prop.Value.mois, Prop.Value.jour, Prop.Value.heures, Prop.Value.minutes);
    } else {
      Prop.Value = new QueovalDateTime();
      Prop.Value.heures = hour;
    }
    if (isInput) {
      this.dtValue?.setMinutes(Number(hour));
    }
  }
  public OnPropMinutesChange(Prop: IBoProperty<QueovalDateTime>, minute: string, isInput: boolean): void {
    if (Prop.Value != null) {
      Prop.Value.minutes = minute;
      Prop.Value = new QueovalDateTime(Prop.Value.annee, Prop.Value.mois, Prop.Value.jour, Prop.Value.heures, Prop.Value.minutes);
    } else {
      Prop.Value = new QueovalDateTime();
      Prop.Value.minutes = minute;
    }
    if (isInput) {
      this.dtValue?.setMinutes(Number(minute));
    }
  }

  public OnCleanDate(Prop: DateRequiredBoProperty): void {
    Prop.Value = null;
  }

  public SetToday(Prop: DateRequiredBoProperty): void {
      Prop.Value = this.dtService.FromDateTime(new Date(Date.now()));
  }
  //#endregion
}


@Pipe({
  name: 'displayValue'
})
export class DisplayValuePipe implements PipeTransform {

  constructor(
    protected indparam: CoreService,
    protected qDtService: QueovalDateService,
  ) { }
  /**
   * 
   * @param value sert à rafraichir le display lorsque la valeur change (ne sert pas dans l'algo)
   * @param property
   * @param type
   */
  transform(value: any, property: IBoProperty<any>, type: BoPropertyType): string {
    if (property.Combo && property.Combo.length > 0) {
      var selectedValue = (property.Combo as Array<GQueovalDik<string, any>>).filter((combo: GQueovalDik<string, any>) => combo.Value === property.Value)
      if (selectedValue && selectedValue.length > 0 && selectedValue[0] != null) return selectedValue[0].Key;
      property.Value = (property.Combo as Array<GQueovalDik<string, any>>)[0].Value
      return (property.Combo as Array<GQueovalDik<string, any>>)[0].Key;
    }
    else {
      switch (type) {
        case 'BOOLEAN':
          return (property as BooleanBoProperty).Value ? this.indparam.getTrad('Yes') : this.indparam.getTrad('no')

        case 'MONETARY':
          if ((property as MonetaryBoProperty).Mask.toUpperCase() == "MONEY") {
            const moneyPipe: MoneyPipe = new MoneyPipe(this.indparam);
            return moneyPipe.transform(property.Value);
          } else {
            return property.Value;
          }

        case 'DATE':
          let date: Date | null;
          const options: any = { weekday: "long", year: "numeric", month: "short", day: "numeric" };
          if (!(property as DateRequiredBoProperty).Value) return '- - - - - -';
          const displayHourMinutes: boolean = (property as DateRequiredBoProperty).DateMinutesList && (property as DateRequiredBoProperty).DateMinutesList.length > 0;
          if (property.Value.annee === '0' || property.Value.mois === '0' || property.Value.jour === '0' || (displayHourMinutes && (property.Value.heures === '' || property.Value.minutes === ''))) {
            date = null;
          } else {
            const strYear: string = Number(property.Value.annee) < 10 ? `000${property.Value.annee}` : Number(property.Value.annee) < 100 ? `00${property.Value.annee}` : Number(property.Value.annee) < 1000 ? `0${property.Value.annee}` : property.Value.annee;
            const strDay: string = Number(property.Value.jour) < 10 ? `0${Number(property.Value.jour)}` : property.Value.jour;
            const strMonth: string = Number(property.Value.mois) < 10 ? `0${Number(property.Value.mois)}` : property.Value.mois;
            const strHour: string = Number(property.Value.heures) < 10 ? `0${Number(property.Value.heures)}` : property.Value.heures;
            const strMinutes: string = Number(property.Value.minutes) < 10 ? `0${Number(property.Value.minutes)}` : property.Value.minutes;
            date = new Date(`${strYear}-${strMonth}-${strDay}T${strHour}:${strMinutes}`);
          }
          if (!this.qDtService.IsNull(property.Value) && displayHourMinutes) {
            options.hour = "numeric";
            options.minute = "numeric"
          }
          if (!date) return '- - - - - -';
          return new Intl.DateTimeFormat(this.indparam.AppParams.culture, options).format(date);
        default:
          return property.Value;
      }
    }
  }
}
